<template>
  <BaseVueSpinner
    v-bind="$attrs"
    v-on="$listeners"
    :spinnerProps="spinnerProps"
    :styleConfig="styleConfig">
    <template v-slot:header>
      <slot name="header" />
    </template>
    <template v-slot:footer>
      <slot name="footer" />
    </template>
  </BaseVueSpinner>
</template>

<script>
  import BaseVueSpinner from '@base/v2/base-vue-spinner'
  import { FontStyle, Layout } from '@js/styles'

  export default {
    name: 'BeatLoaderPrimary',
    inheritAttrs: false,
    components: {
      BaseVueSpinner,
    },
    data: function () {
      return {
        spinnerProps: {
          size: FontStyle.size.md,
        },
        styleConfig: {
          container: {},
          footer: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
            margin: `${Layout.space.md} 0 0 0`,
            textAlign: 'center',
            width: '100%',
          },
          header: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.md,
            fontWeight: FontStyle.weight.md,
            margin: `0 0 ${Layout.space.md} 0`,
            textAlign: 'center',
            width: '100%',
          },
          spinner: {},
        }
      };
    },
  };
</script>
